<template>
  <div v-if="renderReady && !model.$disabled">
    <w-label
      :model="model"
      :title="isTitle ? title : 'Forma Prawna:'"
      :show-label="showLabel"
      :description="description"
      :next-number="nextNumber"
      :bold-label="boldLabel"
      :labelFor="'legal-' + sid"
      :only-description="onlyDescription"
    >
      <template v-slot:prepend>
        <slot name="prependlabel" />
      </template>

      <template v-slot:description>
        <slot name="description" />
      </template>

      <template v-slot:append>
        <slot name="appendlabel" />
      </template>
    </w-label>

    <slot name="content">
      <w-radio v-for="(item, index) in formList" :key="`form_${index}`" :model="model" :showError="false" :value="item">{{ item }}</w-radio>
    </slot>

    <w-error :model="model" />
  </div>
</template>

<script>
import modelMixin from '../../mixins/modelMixin';
import titleMixin from '../../mixins/titleMixin';

import WInput from '../../components/input.vue';
import WRadio from '../../components/radio.vue';

export default {
  name: 'w-legal-form',
  mixins: [modelMixin, titleMixin],
  components: {WInput, WRadio},
  data() {
    return {
      sid: Math.round(Math.random() * 1000000)
    };
  },
  props: {
    formList: {
      type: Array,
      default: () => [
        'Stowarzyszenie Rejestrowe',
        'Stowarzyszenie Zwykłe',
        'Stowarzyszenie Kultury Fizycznej',
        'Stowarzyszenie Ogrodowe',
        'Fundacja',
        'Organizcja powstała na mocy umowy państwo-kościół',
        'Spółdzielnia socjalna',
        'Spółka prawa handlowego'
      ]
    }
  }
};
</script>
